import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Timeline from '../elements/Timeline';
import TimelineItem from '../elements/TimelineItem';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class Roadmap extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'roadmap section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'roadmap-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
      title: 'Get Answers in Minutes',
      paragraph: 'Install Exanta, connect your store, and start asking questions - no technical knowledge required.'
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />
            <Timeline>
              <TimelineItem title="Install the Plugin">
                <div>
                  <div>Add Exanta to your WooCommerce store in just a few minutes.</div>
                </div>
              </TimelineItem>
              <TimelineItem title="Prepare Your Store">
                <div>
                  <div>Log in and click &quot;Analyse Database Structure&quot; so Exanta can understand how your store is organised.</div>
                  <div className="text-sm text-color-low mt-12">
                    Exanta only analyzes your database structure - it does not access or store any customer or order data.
                  </div>
                </div>
              </TimelineItem>
              <TimelineItem title="Ask a Question">
                <div>
                  <div>Type your question in plain English, just like you would ask a colleague.</div>
                  <div className="text-sm text-color-low mt-12">
                    &quot;How many customers registered this month?&quot;
                  </div>
                </div>
              </TimelineItem>
              <TimelineItem title="Get Your Answer">
                <div>
                  <div>Exanta returns clear, accurate answers from your WooCommerce data in seconds.</div>
                  <div className="text-sm text-color-low mt-12">
                    &quot;124 customers registered this month.&quot;
                  </div>
                </div>
              </TimelineItem>
            </Timeline>
            <div className="center-content mt-56">
              <p className="m-0 text-color-low">
                No reports. No spreadsheets. No technical knowledge required.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Roadmap.propTypes = propTypes;
Roadmap.defaultProps = defaultProps;

export default Roadmap;